import { ContentObjectTypes, getContentPropertyValue, getPropertyValue, useContentObjectType } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from 'content-management-details-lib/providers/ContentDetailsDataProvider';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import useAbVariants from '../hooks/useAbVariants';
import useMabExperiment from '../hooks/useMabExperiment';
const useTestResultsData = () => {
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const {
    contentObjectType
  } = useContentObjectType();
  const isLandingPage = contentObjectType === ContentObjectTypes.LANDING_PAGE;
  const mabExperimentId = getPropertyValue(contentObject, PAGE_PROPERTY_NAMES.MAB_EXPERIMENT_ID);
  const pastMabExperimentIds = getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.MAB_PAST_EXPERIMENT_IDS, []);
  const abTestId = getPropertyValue(contentObject, PAGE_PROPERTY_NAMES.AB_TEST_ID);
  const mabInfo = useMabExperiment({
    mabExperimentId,
    isLandingPage
  });
  const abInfo = useAbVariants({
    abTestId,
    isLandingPage
  });
  return Object.assign({}, mabInfo, abInfo, {
    mabExperimentId,
    abTestId,
    pastMabExperimentIds
  });
};
export default useTestResultsData;